var map = {
	".": 18305,
	"./": 18305,
	"./App": 6635,
	"./App.css": 93508,
	"./App.js": 6635,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./data": 30468,
	"./data.json": 30468,
	"./images/Thumbs.db": 5327,
	"./images/avatars/Thumbs.db": 63441,
	"./images/avatars/image-amyrobson.png": 81695,
	"./images/avatars/image-amyrobson.webp": 70594,
	"./images/avatars/image-juliusomo.png": 26040,
	"./images/avatars/image-juliusomo.webp": 62001,
	"./images/avatars/image-maxblagun.png": 24353,
	"./images/avatars/image-maxblagun.webp": 79070,
	"./images/avatars/image-ramsesmiron.png": 23754,
	"./images/avatars/image-ramsesmiron.webp": 60430,
	"./images/favicon-32x32.png": 66036,
	"./images/icon-delete.svg": 61086,
	"./images/icon-edit.svg": 44702,
	"./images/icon-minus.svg": 10207,
	"./images/icon-plus.svg": 76371,
	"./images/icon-reply.svg": 89240,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./timestamp": 87925,
	"./timestamp.js": 87925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;